// import { ethers } from 'ethers'
// import { SenderTokenABI } from '@/config'


// const batchAirEth = (senderContractAddress: string, signer, tokens: any[], amounts: any[], decimals: number, yagongPrice: number) => {
//   return new Promise(async (resolve, reject) => {
//     const contract = new ethers.Contract(senderContractAddress, SenderTokenABI, signer)
//     const _amounts = []
//     amounts.forEach((amount) => {
//       const _amount = ethers.utils.parseUnits(amount, decimals)
//       _amounts.push(_amount.toString())
//     })
//     const price = ethers.utils.parseEther(yagongPrice.toString())
//     try {

//       const gasOptions = {
//         value: price,
//         gasLimit: await contract.estimateGas.batchAirEth(tokens, _amounts, { value: price })
//       };

//       // 传入Gas参数执行交易
//       const res = await contract.batchAirEth(tokens, _amounts, gasOptions);
//       signer.provider.once(res.hash, () => {
//         resolve(true)
//       })
//     } catch (error) {
//       reject(error)
//     }
//   })
// }
// export default batchAirEth


import {
  parseUnits,
  parseEther,
  type WalletClient,
  type PublicClient,
  type Address,
} from 'viem'
import { SenderTokenABI } from '@/config'

const batchAirEth = async (
  senderContractAddress: Address,
  walletClient: WalletClient,
  publicClient: PublicClient,
  tokens: string[],
  amounts: string[],
  decimals: number,
  yagongPrice: number,
): Promise<boolean> => {
  try {
    // 解析金额
    const _amounts = amounts.map((amount) =>
      parseUnits(amount, decimals)
    )
    console.log('_amounts::: ', _amounts)

    // 解析价格
    const price = parseEther(yagongPrice.toString())
    console.log('yagongPrice::: ', yagongPrice)

    // 预估 gas
    const gas = await publicClient.estimateContractGas({
      address: senderContractAddress,
      abi: SenderTokenABI,
      functionName: 'batchAirEth',
      args: [tokens, _amounts],
      value: price,
      account: walletClient.account,
    })

    // 调用合约
    const hash = await walletClient.writeContract({
      address: senderContractAddress,
      abi: SenderTokenABI,
      functionName: 'batchAirEth',
      args: [tokens, _amounts],
      value: price,
      gas,
      chain: undefined,
      account: walletClient.account.address,
    })

    await publicClient.waitForTransactionReceipt({
      hash,
      confirmations: 1,  // 等待1个确认
      timeout: 10000
    })

    return true
  } catch (error) {
    throw error
  }
}

export default batchAirEth